import React, { lazy, Suspense } from "react";
import {
    Route,
    Routes,
    BrowserRouter,
    Navigate,
    Outlet,
    useLocation,
} from "react-router-dom";

import Application from "../components/pages/Application";
import { PublicRoute, PrivateRoute } from "./RouteTypes";
import UiRoutes from "./UiRoutes";
import ScrollToTop from "../components/common/ScrollToTop";
import { SuspenseLoading } from "../components/_uiComponents/common/UiLoadingSpinner";
// import ProductTargetIncentives from "../components/_uiMocks/pages/incentives/custom/ProductTargetIncentives";
// import ProductTargetIncentivesTwo from "../components/_uiMocks/pages/incentives/custom/ProductTargetIncentivesTwo";
// import LeagueIncentivesCastrol from "../components/_uiMocks/pages/incentives/custom/LeagueIncentivesCastrol";
// import LeagueIncentives from "../components/_uiMocks/pages/incentives/custom/LeagueIncentives";
// import ProductTargetIncentivesQ4 from "../components/_uiMocks/pages/incentives/custom/ProductTargetIncentivesQ4";
// import LeagueIncentivesQ4Castrol from "../components/_uiMocks/pages/incentives/custom/LeagueIncentivesQ4Castrol";
// import LeagueIncentivesQ4Winter from "../components/_uiMocks/pages/incentives/custom/LeagueIncentivesQ4Winter";
import OtpWrapper from "../components/pages/auth/OtpWrapper";
import ForgotPasswordWrapper from "../components/pages/auth/ForgotPasswordWrapper";
import ResetPasswordWrapper from "../components/pages/auth/ResetPasswordWrapper";
import AboutusSection from "../components/pages/auth/AboutusSection";
import SignUpWrapper from "../components/pages/auth/SignUpWrapper";
import { useSelector } from "react-redux";

const IncentiveRenaultWrapper = lazy(() =>
    import("../components/pages/incentive/IncentiveRenaultWrapper"),
);
const IncentiveDetails = lazy(() =>
    import("../components/pages/incentive/IncentiveDetails"),
);

const ProductTargetIncentives = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/ProductTargetIncentives"
    ),
);

const ProductTargetIncentivesTwo = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/ProductTargetIncentivesTwo"
    ),
);

const LeagueIncentivesCastrol = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/LeagueIncentivesCastrol"
    ),
);

const LeagueIncentivesQ4Castrol = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/LeagueIncentivesQ4Castrol"
    ),
);

const ProductTargetIncentivesQ4 = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/ProductTargetIncentivesQ4"
    ),
);

const LeagueIncentivesQ4Winter = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/LeagueIncentivesQ4Winter"
    ),
);

const IncentivesBanded = lazy(() =>
    import("../components/_uiMocks/pages/incentives/custom/IncentivesBanded"),
);

const CastrolSpinWin = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/equipe/CastrolSpinWin"
    ),
);

const LeagueIncentivesQ4 = lazy(() =>
    import("../components/_uiMocks/pages/incentives/custom/LeagueIncentivesQ4"),
);

const IncentivesBandedNovember = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/tlc/IncentivesBandedNovember"
    ),
);

const IncentivesBandedDecember = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/tlc/IncentivesBandedDecember"
    ),
);

const IncentivesBandedJanuary = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/tlc/IncentivesBandedJanuary"
    ),
);

const IncentivesBandedFebruary = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/tlc/IncentivesBandedFebruary"
    ),
);

const IncentivesBandedMarch = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/tlc/IncentivesBandedMarch"
    ),
);

const IncentivesBandedApril = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/tlc/IncentivesBandedApril"
    ),
);

const IncentivesBandedMay = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/tlc/IncentivesBandedMay"
    ),
);

const IncentivesBandedJune = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/tlc/IncentivesBandedJune"
    ),
);

const IncentivesBandedJuly = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/tlc/IncentivesBandedJuly"
    ),
);

const IncentivesBandedAugust = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/tlc/IncentivesBandedAugust"
    ),
);

const IncentivesBandedSeptember = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/tlc/IncentivesBandedSeptember"
    ),
);

const IncentivesBandedOctober = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/tlc/IncentivesBandedOctober"
    ),
);

const TlcBandedDecember = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/tlc/TlcBandedDecember"
    ),
);

const AlpineCustomerExcellence = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/equipe/AlpineCustomerExcellence"
    ),
);

const TradePartsManagerIncentive = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/equipe/TradePartsManagerIncentive"
    ),
);

const AbuDhabiWinnersHome = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/equipe/abu-dhabi-winners/AbuDhabiWinnersHome"
    ),
);

const AbuDhabiDayOne = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/equipe/abu-dhabi-winners/AbuDhabiDayOne"
    ),
);

const AbuDhabiDayTwo = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/equipe/abu-dhabi-winners/AbuDhabiDayTwo"
    ),
);

const AbuDhabiDayThree = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/equipe/abu-dhabi-winners/AbuDhabiDayThree"
    ),
);

const AbuDhabiDayFour = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/equipe/abu-dhabi-winners/AbuDhabiDayFour"
    ),
);

const AlpineCampaign = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/equipe/2026/AlpineCampaign"
    ),
);

const ServiceStarsWinners2026 = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/equipe/ServiceStarsWinners2026"
    ),
);

const RenaultHomeWrapper = lazy(() =>
    import("../components/pages/home-renault/RenaultHomeWrapper"),
);

const RetailSalesHomeWrapper = lazy(() =>
    import("../components/pages/home-retail-sales/RetailSalesHomeWrapper"),
);

const KnowlegeWrapper = lazy(() =>
    import("../components/pages/learn/KnowlegeWrapper"),
);

const ShopWrapper = lazy(() => import("../components/pages/shop/ShopWrapper"));
const VoucherDetails = lazy(() =>
    import("../components/pages/shop/VoucherDetails"),
);

const RebateVoucherDetails = lazy(() =>
    import("../components/pages/shop/RebateVoucherDetails"),
);

const OrderConfirmation = lazy(() =>
    import("../components/pages/shop/OrderConfirmation"),
);

const VoucherWallet = lazy(() =>
    import("../components/pages/shop/VoucherWallet"),
);

const BrowseProducts = lazy(() =>
    import("../components/pages/shop/BrowseProducts"),
);

const OrderDetails = lazy(() =>
    import("../components/pages/shop/OrderDetails"),
);

const PointsBankingWrapper = lazy(() =>
    import("../components/pages/points-bankings-renault/PointsBankingWrapper"),
);

const RenaultPointsBankingWrapper = lazy(() =>
    import("../components/pages/points-bankings-renault/PointsBankingWrapper"),
);

const AllQuizzers = lazy(() => import("../components/pages/learn/AllQuizzers"));

const QuizHome = lazy(() => import("../components/pages/learn/QuizHome"));

const CommsPage = lazy(() =>
    import("../components/_uiMocks/pages/CommsPage/CommsPage"),
);

const CommsPageOne = lazy(() =>
    import("../components/pages/comms-templates/CommsPageOne"),
);

const CommsPageTwo = lazy(() =>
    import("../components/pages/comms-templates/CommsPageTwo"),
);

const CommsPageThree = lazy(() =>
    import("../components/pages/comms-templates/CommsPageThree"),
);

const CommsPageFour = lazy(() =>
    import("../components/pages/comms-templates/CommsPageFour"),
);

const CommsWrapper = lazy(() =>
    import("../components/pages/comms-templates/CommsWrapper"),
);

const CommsPageFive = lazy(() =>
    import("../components/pages/comms-templates/CommsPageFive"),
);

const CommsPageSix = lazy(() =>
    import("../components/pages/comms-templates/CommsPageSix"),
);

const CommsPageSeven = lazy(() =>
    import("../components/pages/comms-templates/CommsPageSeven"),
);

const CommsPageEight = lazy(() =>
    import("../components/pages/comms-templates/CommsPageAbuDhabiIncetive"),
);

const CommsPageMotrio = lazy(() =>
    import("../components/pages/comms-templates/CommsPageMotrio"),
);

const ServiceStars2025 = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/equipe/ServiceStars2025"
    ),
);

const CastrolMotoGp = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/equipe/CastrolMotoGp"
    ),
);

const AugustGoldenTicket = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/equipe/AugustGoldenTicket"
    ),
);

const BrakePadsIncentive = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/equipe/BrakePadsIncentive"
    ),
);

const FocusOnBatteries = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/equipe/FocusOnBatteries"
    ),
);

const OptimumFriction = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/equipe/2026/OptimumFriction"
    ),
);

const EvhcFocus = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/equipe/2026/EvhcFocus"
    ),
);

const IcrmGameOn = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/equipe/2026/IcrmGameOn"
    ),
);
// const EvhcFocusDoublePoints = lazy(() =>
//     import(
//         "../components/_uiMocks/pages/incentives/custom/equipe/2026/EvhcFocusDoublePoints"
//     ),
// );

const ServiceStars = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/equipe/2026/ServiceStars"
    ),
);

const TpmCuttingEdge = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/equipe/2026/TpmCuttingEdge"
    ),
);

const RenaultRewardsCampaign = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/equipe/2026/RenaultRewardsCampaign"
    ),
);

const MotrioPaydays = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/equipe/2026/MotrioPaydays"
    ),
);

const LcvSalesTeamIncentive = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/equipe/2026/LcvSalesTeamIncentive"
    ),
);
const LcvSleighQ4Incentive = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/equipe/2026/LcvSleighQ4Incentive"
    ),
);
const MotrioRewardsCampaign = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/tlc/2026/MotrioRewardsCampaign"
    ),
);

const WipersIncentive = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/equipe/WipersIncentive"
    ),
);

const MyBasket = lazy(() => import("../components/pages/shop/MyBasket"));

const ProductTargetIncentivesJanuary = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/equipe/ProductTargetIncentivesJanuary"
    ),
);

const ProductTargetIncentivesFebruary = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/equipe/ProductTargetIncentivesFebruary"
    ),
);

const MarchGoldenTickets = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/equipe/MarchGoldenTickets"
    ),
);

const IncentiveWearAndTear = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/equipe/IncentiveWearAndTear"
    ),
);
const QtwoWearAndTear = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/equipe/QtwoWearAndTear"
    ),
);
const QthreeWearAndTear = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/equipe/QthreeWearAndTear"
    ),
);
const TradePartsManagerTlcView = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/equipe/TradePartsManagerTlcView"
    ),
);

const FullThrottle = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/equipe/FullThrottle"
    ),
);

const MayGoldenTicket = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/equipe/MayGoldenTicket"
    ),
);

const CuttingEdgeQuarterThree = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/equipe/CuttingEdgeQuarterThree"
    ),
);

const CuttingEdgeQuarterFour = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/equipe/CuttingEdgeQuarterFour"
    ),
);
const CastrolFiveHundred = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/equipe/CastrolFiveHundred"
    ),
);

const TradePartsManagerSpinWin = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/equipe/TradePartsManagerSpinWin"
    ),
);

const SalesManagerTravelIncentive = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/equipe/SalesManagerTravelIncentive"
    ),
);

const CastrolLiquidGold = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/equipe/CastrolLiquidGold"
    ),
);
// const CastrolLegends = lazy(() =>
//     import(
//         "../components/_uiMocks/pages/incentives/custom/equipe/2026/CastrolLegends"
//     ),
// );

const RemanIncentive = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/equipe/2026/RemanIncentive"
    ),
);

// Thoughtspot visual insights embeddings
const VisualInsights = lazy(() =>
    import("../components/pages/insight/VisualInsights"),
);

import {
    participantJobRoleIds,
    contextApiActions,
    participantTypeIds,
    participantUrl,
    isShopOnlyJobRole,
    isLcvJobRole,
    isLcvAccessJobRole,
} from "../_redux/_constants";
import RedirectRoutes from "./RedirectRouters";

export default function MainRoutes() {
    const { userProfileDetails } = useSelector((state) => {
        return {
            userProfileDetails: state.auth.userProfileDetails,
        };
    });

    // The job role decides which home page a participant gets and whether campaigns exist for
    // them. Until it has actually arrived it is neither retail nor non-retail, and it must not be
    // read as "not retail" - that is what exposes Equipe to a retail winner on a failed profile
    // call.
    const isJobRoleKnown =
        userProfileDetails?.jobRoleId !== undefined &&
        userProfileDetails?.jobRoleId !== null &&
        userProfileDetails?.jobRoleId !== "";

    const visibleCustomerId = [
        2000038, 2000110, 2000152, 2000599, 2000319, 2000085, 2000382, 2000164,
        2000104, 2000069, 2000035, 2000034, 1000001, 2000588, 2000670, 2000669,
    ];
    const alpineVisibleCustomerId = [
        2000034, 2000381, 2000382, 2000383, 2000384, 2000385, 2000404, 2000673,
        2000674, 2002124, 2000071, 2001706, 2001726, 2000928, 2000223, 2000671,
        2013862, 2000112, 2000647, 2000178, 2000105, 2000109, 1000001, 2000035,
        2000038, 2000588, 2000593, 2000610, 2000789, 2000816, 2001078, 2001083,
        2002127, 2013853, 2013925,
    ];

    const hostname = window.location.hostname
        .replace(".com", "")
        .split(".")
        .pop();
    const isTlc = hostname === participantUrl.RENAULT_TLC_URL;

    return (
        <ScrollToTop>
            <Routes>
                {/* Public routes */}
                <Route
                    path="/"
                    element={
                        <PublicRoute>
                            <Application />
                        </PublicRoute>
                    }
                />
                <Route
                    path="/auth/*"
                    element={
                        <>
                            <Outlet />
                        </>
                    }
                >
                    <Route
                        path="otp-verification/:id/:userId"
                        element={
                            <PublicRoute>
                                <OtpWrapper />
                            </PublicRoute>
                        }
                    />
                    <Route
                        path="forgot-password"
                        element={
                            <PublicRoute>
                                <ForgotPasswordWrapper />
                            </PublicRoute>
                        }
                    />
                    <Route
                        path="set-password"
                        element={
                            <PublicRoute>
                                <ResetPasswordWrapper />
                            </PublicRoute>
                        }
                    />

                    <Route
                        path="sign-up"
                        element={
                            <PublicRoute>
                                <SignUpWrapper />
                            </PublicRoute>
                        }
                    />
                </Route>

                <Route
                    path="/about"
                    element={
                        <PublicRoute>
                            {isTlc ? (
                                <AboutusSection />
                            ) : (
                                <Navigate to="/" replace />
                            )}
                        </PublicRoute>
                    }
                />

                {/* <Route
                    path="/:id"
                    element={
                        <PublicRoute>
                            <Suspense fallback={<SuspenseLoading />}>
                                <SignUpWrapper />
                            </Suspense>
                        </PublicRoute>
                    }
                /> */}

                {/* Public routes */}
                {/* Private routes */}

                <Route path="/app/*" element={<PrivateRoute />}>
                    {/* Retail sales roles get the shop-only home page.

                        Until the job role has actually arrived, neither page is rendered. Treating
                        an unknown role as "not retail" would hand a retail winner the full Equipe
                        home page and the Campaigns menu whenever the profile call is slow or
                        fails. */}
                    <Route
                        path="home"
                        element={
                            !isJobRoleKnown ? (
                                <SuspenseLoading />
                            ) : isShopOnlyJobRole(
                                  userProfileDetails?.jobRoleId,
                              ) ? (
                                <RetailSalesHomeWrapper />
                            ) : (
                                <RenaultHomeWrapper />
                            )
                        }
                    />
                    {/* <Route path="home-renault" element={<RenaultHomeWrapper />} /> */}
                    {userProfileDetails?.jobRoleId ===
                        participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_NATIONAL_MANAGER &&
                        [
                            1000001, 2000035, 2000588, 2000038, 2013925,
                            2013935, 2015907,
                        ].includes(userProfileDetails?.userId) && (
                            <Route
                                path="insights"
                                element={<VisualInsights />}
                            />
                        )}
                    {/* Retail sales roles have no campaigns, so the campaign
                        home page is not registered for them. The route is also withheld until the
                        job role is known, so an unresolved profile cannot expose it. */}
                    {isJobRoleKnown &&
                        !isShopOnlyJobRole(userProfileDetails?.jobRoleId) && (
                            <Route
                                path="campaigns"
                                element={<IncentiveRenaultWrapper />}
                            />
                        )}
                    {userProfileDetails?.jobRoleId ==
                        participantJobRoleIds.TLC_TRADE_REP && (
                        <>
                            <Route
                                path="campaigns/378"
                                element={<MotrioRewardsCampaign />}
                            />
                            <Route
                                path="campaigns/376"
                                element={<RenaultRewardsCampaign />}
                            />
                            <Route
                                path="campaigns/267"
                                element={<TlcBandedDecember />}
                            />
                            {/* A trade rep on Equipe also views the three trade campaigns. */}
                            {userProfileDetails?.roleId ==
                                participantTypeIds.PARTICIPANT && (
                                <>
                                    <Route
                                        path="campaigns/375"
                                        element={<TpmCuttingEdge />}
                                    />
                                    <Route
                                        path="campaigns/377"
                                        element={<MotrioPaydays />}
                                    />
                                    <Route
                                        path="campaigns/409"
                                        element={<RemanIncentive />}
                                    />
                                </>
                            )}
                        </>
                    )}
                    {userProfileDetails?.jobRoleId ==
                        participantJobRoleIds.TLC_PARTICIPANT_AREA_MANAGER && (
                        <>
                            <Route
                                path="campaigns/378"
                                element={<MotrioRewardsCampaign />}
                            />
                            <Route
                                path="campaigns/376"
                                element={<RenaultRewardsCampaign />}
                            />
                            <Route
                                path="campaigns/267"
                                element={<TlcBandedDecember />}
                            />
                        </>
                    )}

                    {userProfileDetails?.jobRoleId ==
                        participantJobRoleIds.TLC_PARTICIPANT_CUSTOMER &&
                        participantTypeIds.TLC_PARTICIPANT ==
                            userProfileDetails?.roleId && (
                            <>
                                {userProfileDetails?.isMotrioCustomer && (
                                    <>
                                        <Route
                                            path="campaigns/378"
                                            element={<MotrioRewardsCampaign />}
                                        />
                                    </>
                                )}

                                <Route
                                    path="campaigns/376"
                                    element={<RenaultRewardsCampaign />}
                                />

                                {userProfileDetails?.isTlc2025Customer && (
                                    <Route
                                        path="campaigns/267"
                                        element={<TlcBandedDecember />}
                                    />
                                )}
                            </>
                        )}
                    {isLcvAccessJobRole(userProfileDetails?.jobRoleId) &&
                        participantTypeIds.PARTICIPANT ==
                            userProfileDetails?.roleId && (
                            <>
                                <Route
                                    path="campaigns/410"
                                    element={<LcvSalesTeamIncentive />}
                                />
                                <Route
                                    path="campaigns/413"
                                    element={<LcvSleighQ4Incentive />}
                                />
                                <Route
                                    path="campaigns/127"
                                    element={<SalesManagerTravelIncentive />}
                                />
                            </>
                        )}

                    {userProfileDetails?.jobRoleId ==
                        participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_SERVICE_ADVISOR &&
                    participantTypeIds.PARTICIPANT ==
                        userProfileDetails?.roleId ? (
                        <>
                            {/* <Route
                                path="campaigns/368"
                                element={<QthreeWearAndTear />}
                            /> */}
                            <Route
                                path="campaigns/379"
                                element={<CastrolLiquidGold />}
                            />

                            <Route
                                path="campaigns/315"
                                element={<IncentiveWearAndTear />}
                            />

                            <Route
                                path="campaigns/313"
                                element={<ProductTargetIncentivesFebruary />}
                            />

                            <Route
                                path="campaigns/310"
                                element={<ProductTargetIncentivesQ4 />}
                            />

                            <Route
                                path="campaigns/312"
                                element={<ProductTargetIncentivesJanuary />}
                            />

                            <Route
                                path="campaigns/270"
                                element={<ProductTargetIncentivesTwo />}
                            />
                            <Route
                                path="campaigns/290"
                                element={<ProductTargetIncentives />}
                            />
                            {/* <Route
                                path="campaigns/125"
                                element={<CastrolSpinWin />}
                            /> */}

                            <Route
                                path="campaigns/125/:id"
                                element={<CastrolSpinWin />}
                            />
                            <Route
                                path="campaigns/373"
                                element={<EvhcFocus />}
                            />
                            <Route
                                path="campaigns/412"
                                element={<OptimumFriction />}
                            />
                            {/* <Route
                                path="campaigns/373"
                                element={<EvhcFocusDoublePoints />}
                            /> */}
                            {visibleCustomerId?.includes(
                                userProfileDetails?.userId,
                            ) && (
                                <>
                                    <Route
                                        path="campaigns/325"
                                        element={<AbuDhabiWinnersHome />}
                                    />
                                    <Route
                                        path="campaigns/winners/day-01"
                                        element={<AbuDhabiDayOne />}
                                    />

                                    <Route
                                        path="campaigns/winners/day-02"
                                        element={<AbuDhabiDayTwo />}
                                    />

                                    <Route
                                        path="campaigns/winners/day-03"
                                        element={<AbuDhabiDayThree />}
                                    />

                                    <Route
                                        path="campaigns/winners/day-04"
                                        element={<AbuDhabiDayFour />}
                                    />
                                </>
                            )}
                            {/* {alpineVisibleCustomerId?.includes(
                                userProfileDetails?.userId,
                            ) && (
                                <>
                                    <Route
                                        path="campaigns/130"
                                        element={<AlpineCustomerExcellence />}
                                    />
                                    <Route
                                        path="campaigns/131"
                                        element={<AlpineCampaign />}
                                    />
                                </>
                            )} */}
                        </>
                    ) : userProfileDetails?.jobRoleId ==
                          participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_SERVICE_MANAGER &&
                      participantTypeIds.PARTICIPANT ==
                          userProfileDetails?.roleId ? (
                        <>
                            <Route
                                path="campaigns/382"
                                element={<IcrmGameOn />}
                            />

                            {/* <Route
                                path="campaigns/380"
                                element={<CastrolLegends />}
                            /> */}
                            {/* <Route
                                path="campaigns/368"
                                element={<QthreeWearAndTear />}
                            /> */}
                            {/* <Route
                                path="campaigns/365"
                                element={<CastrolFiveHundred />}
                            /> */}
                            <Route
                                path="campaigns/379"
                                element={<CastrolLiquidGold />}
                            />

                            <Route
                                path="campaigns/282"
                                element={<IncentivesBandedApril />}
                            />

                            <Route
                                path="campaigns/350"
                                element={<LeagueIncentivesQ4Winter />}
                            />
                            <Route
                                path="campaigns/320"
                                element={<LeagueIncentivesQ4Castrol />}
                            />
                            <Route
                                path="campaigns/280"
                                element={<LeagueIncentivesCastrol />}
                            />
                            <Route
                                path="campaigns/310"
                                element={<ProductTargetIncentivesQ4 />}
                            />
                            <Route
                                path="campaigns/315"
                                element={<IncentiveWearAndTear />}
                            />

                            <Route
                                path="campaigns/313"
                                element={<ProductTargetIncentivesFebruary />}
                            />

                            {/* <Route
                                path="campaigns/316"
                                element={<CastrolMotoGp />}
                            /> */}

                            <Route
                                path="campaigns/312"
                                element={<ProductTargetIncentivesJanuary />}
                            />
                            <Route
                                path="campaigns/270"
                                element={<ProductTargetIncentivesTwo />}
                            />
                            <Route
                                path="campaigns/290"
                                element={<ProductTargetIncentives />}
                            />
                            {/* <Route
                                path="campaigns/128"
                                element={<ServiceStars2025 />}
                            /> */}

                            {/* <Route
                                path="campaigns/125"
                                element={<CastrolSpinWin />}
                            /> */}
                            {/* 
                            <Route
                                path="campaigns/369"
                                element={<AugustGoldenTicket />}
                            /> */}

                            {/* <Route
                                path="campaigns/370"
                                element={<BrakePadsIncentive />}
                            /> */}
                            {/* <Route
                                path="campaigns/372"
                                element={<FocusOnBatteries />}
                            /> */}
                            <Route
                                path="campaigns/373"
                                element={<EvhcFocus />}
                            />
                            <Route
                                path="campaigns/412"
                                element={<OptimumFriction />}
                            />
                            {/* <Route
                                path="campaigns/373"
                                element={<EvhcFocusDoublePoints />}
                            /> */}
                            <Route
                                path="campaigns/374"
                                element={<ServiceStars />}
                            />
                            <Route
                                path="campaigns/service-stars-winners/2026"
                                element={<ServiceStarsWinners2026 />}
                            />
                            <Route
                                path="campaigns/375"
                                element={<TpmCuttingEdge />}
                            />
                            {/* <Route
                                path="campaigns/371"
                                element={<WipersIncentive />}
                            /> */}

                            <Route
                                path="campaigns/125/:id"
                                element={<CastrolSpinWin />}
                            />
                            {alpineVisibleCustomerId?.includes(
                                userProfileDetails?.userId,
                            ) && (
                                <>
                                    <Route
                                        path="campaigns/130"
                                        element={<AlpineCustomerExcellence />}
                                    />
                                    <Route
                                        path="campaigns/131"
                                        element={<AlpineCampaign />}
                                    />
                                </>
                            )}

                            {visibleCustomerId?.includes(
                                userProfileDetails?.userId,
                            ) && (
                                <>
                                    <Route
                                        path="campaigns/325"
                                        element={<AbuDhabiWinnersHome />}
                                    />
                                    <Route
                                        path="campaigns/winners/day-01"
                                        element={<AbuDhabiDayOne />}
                                    />

                                    <Route
                                        path="campaigns/winners/day-02"
                                        element={<AbuDhabiDayTwo />}
                                    />

                                    <Route
                                        path="campaigns/winners/day-03"
                                        element={<AbuDhabiDayThree />}
                                    />

                                    <Route
                                        path="campaigns/winners/day-04"
                                        element={<AbuDhabiDayFour />}
                                    />
                                </>
                            )}
                        </>
                    ) : userProfileDetails?.jobRoleId ===
                          participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_SERVICE_AREA_MANAGER &&
                      participantTypeIds.PARTICIPANT ==
                          userProfileDetails?.roleId ? (
                        <>
                            {/* <Route
                                path="campaigns/409"
                                element={<RemanIncentive />}
                            /> */}
                            <Route
                                path="campaigns/382"
                                element={<IcrmGameOn />}
                            />
                            {/* <Route
                                path="campaigns/380"
                                element={<CastrolLegends />}
                            /> */}
                            {/* <Route
                                path="campaigns/370"
                                element={<BrakePadsIncentive />}
                            /> */}
                            <Route
                                path="campaigns/379"
                                element={<CastrolLiquidGold />}
                            />
                            <Route
                                path="campaigns/376"
                                element={<RenaultRewardsCampaign />}
                            />
                            <Route
                                path="campaigns/372"
                                element={<FocusOnBatteries />}
                            />
                            <Route
                                path="campaigns/373"
                                element={<EvhcFocus />}
                            />
                            <Route
                                path="campaigns/412"
                                element={<OptimumFriction />}
                            />
                            {/* <Route
                                path="campaigns/373"
                                element={<EvhcFocusDoublePoints />}
                            /> */}
                            <Route
                                path="campaigns/374"
                                element={<ServiceStars />}
                            />
                            <Route
                                path="campaigns/service-stars-winners/2026"
                                element={<ServiceStarsWinners2026 />}
                            />
                            <Route
                                path="campaigns/375"
                                element={<TpmCuttingEdge />}
                            />

                            {/* <Route
                                path="campaigns/371"
                                element={<WipersIncentive />}
                            /> */}
                            {/* <Route
                                path="campaigns/368"
                                element={<QthreeWearAndTear />}
                            /> */}
                            {/* <Route
                                path="campaigns/366"
                                element={<CuttingEdgeQuarterThree />}
                            /> */}
                            {/* <Route
                                path="campaigns/367"
                                element={<CuttingEdgeQuarterFour />}
                            /> */}
                            {/* <Route
                                path="campaigns/365"
                                element={<CastrolFiveHundred />}
                            /> */}
                            {/* <Route
                                path="campaigns/314"
                                element={<TradePartsManagerIncentive />}
                            /> */}

                            {/* <Route
                                path="campaigns/330"
                                element={<FullThrottle />}
                            /> */}

                            <Route
                                path="campaigns/315"
                                element={<IncentiveWearAndTear />}
                            />

                            {visibleCustomerId?.includes(
                                userProfileDetails?.userId,
                            ) && (
                                <>
                                    <Route
                                        path="campaigns/325"
                                        element={<AbuDhabiWinnersHome />}
                                    />
                                    <Route
                                        path="campaigns/winners/day-01"
                                        element={<AbuDhabiDayOne />}
                                    />

                                    <Route
                                        path="campaigns/winners/day-02"
                                        element={<AbuDhabiDayTwo />}
                                    />

                                    <Route
                                        path="campaigns/winners/day-03"
                                        element={<AbuDhabiDayThree />}
                                    />

                                    <Route
                                        path="campaigns/winners/day-04"
                                        element={<AbuDhabiDayFour />}
                                    />
                                </>
                            )}
                            {alpineVisibleCustomerId?.includes(
                                userProfileDetails?.userId,
                            ) && (
                                <>
                                    <Route
                                        path="campaigns/130"
                                        element={<AlpineCustomerExcellence />}
                                    />
                                    <Route
                                        path="campaigns/131"
                                        element={<AlpineCampaign />}
                                    />
                                </>
                            )}
                            <Route
                                path="campaigns/290"
                                element={<ProductTargetIncentives />}
                            />
                            <Route
                                path="campaigns/310"
                                element={<ProductTargetIncentivesQ4 />}
                            />
                            <Route
                                path="campaigns/312"
                                element={<ProductTargetIncentivesJanuary />}
                            />

                            <Route
                                path="campaigns/313"
                                element={<ProductTargetIncentivesFebruary />}
                            />

                            <Route
                                path="campaigns/270"
                                element={<ProductTargetIncentivesTwo />}
                            />

                            <Route
                                path="campaigns/350"
                                element={<LeagueIncentivesQ4Winter />}
                            />
                            <Route
                                path="campaigns/320"
                                element={<LeagueIncentivesQ4Castrol />}
                            />
                            <Route
                                path="campaigns/280"
                                element={<LeagueIncentivesCastrol />}
                            />
                            {/* <Route
                                path="campaigns/125"
                                element={<CastrolSpinWin />}
                            /> */}
                            {/* <Route
                                path="campaigns/128"
                                element={<ServiceStars2025 />}
                            /> */}

                            <Route
                                path="campaigns/125/:id"
                                element={<CastrolSpinWin />}
                            />

                            <Route
                                path="campaigns/315"
                                element={<IncentiveWearAndTear />}
                            />

                            {/* <Route
                                path="campaigns/316"
                                element={<CastrolMotoGp />}
                            /> */}

                            {/* <Route
                                path="campaigns/278"
                                element={<TradePartsManagerTlcView />}
                            /> */}

                            {userProfileDetails?.area === "0" && (
                                <>
                                    {/* <Route
                                        path="campaigns/316"
                                        element={<CastrolMotoGp />}
                                    /> */}

                                    {/* <Route
                                        path="campaigns/278"
                                        element={<TradePartsManagerTlcView />}
                                    /> */}
                                    {/* <Route
                                        path="campaigns/314"
                                        element={<TradePartsManagerIncentive />}
                                    /> */}
                                </>
                            )}
                        </>
                    ) : userProfileDetails?.jobRoleId ===
                          participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_NATIONAL_MANAGER &&
                      participantTypeIds.PARTICIPANT ==
                          userProfileDetails?.roleId ? (
                        <>
                            <Route
                                path="campaigns/382"
                                element={<IcrmGameOn />}
                            />
                            <Route
                                path="campaigns/409"
                                element={<RemanIncentive />}
                            />
                            <Route
                                path="campaigns/379"
                                element={<CastrolLiquidGold />}
                            />
                            <Route
                                path="campaigns/service-stars-winners/2026"
                                element={<ServiceStarsWinners2026 />}
                            />
                            {/* <Route
                                path="campaigns/371"
                                element={<WipersIncentive />}
                            /> */}
                            {/* <Route
                                path="campaigns/314"
                                element={<TradePartsManagerIncentive />}
                            /> */}
                            {/* <Route
                                path="campaigns/368"
                                element={<QthreeWearAndTear />}
                            /> */}
                            {/* <Route
                                path="campaigns/366"
                                element={<CuttingEdgeQuarterThree />}
                            /> */}
                            {/* <Route
                                path="campaigns/367"
                                element={<CuttingEdgeQuarterFour />}
                            /> */}

                            {/* <Route
                                path="campaigns/365"
                                element={<CastrolFiveHundred />}
                            /> */}
                            {/* <Route
                                path="campaigns/380"
                                element={<CastrolLegends />}
                            /> */}

                            <Route
                                path="campaigns/290"
                                element={<ProductTargetIncentives />}
                            />

                            <Route
                                path="campaigns/270"
                                element={<ProductTargetIncentivesTwo />}
                            />
                            <Route
                                path="campaigns/310"
                                element={<ProductTargetIncentivesQ4 />}
                            />
                            <Route
                                path="campaigns/312"
                                element={<ProductTargetIncentivesJanuary />}
                            />
                            <Route
                                path="campaigns/350"
                                element={<LeagueIncentivesQ4Winter />}
                            />
                            <Route
                                path="campaigns/320"
                                element={<LeagueIncentivesQ4Castrol />}
                            />
                            <Route
                                path="campaigns/260"
                                element={<IncentivesBanded />}
                            />
                            <Route
                                path="campaigns/280"
                                element={<LeagueIncentivesCastrol />}
                            />
                            {/* <Route
                                path="campaigns/125"
                                element={<CastrolSpinWin />}
                            /> */}
                            {/* <Route
                                path="campaigns/125/:id"
                                element={<CastrolSpinWin />}
                            /> */}
                            {/* <Route
                                path="campaigns/128"
                                element={<ServiceStars2025 />}
                            /> */}
                            <Route
                                path="campaigns/325"
                                element={<AbuDhabiWinnersHome />}
                            />
                            {/* <Route
                                path="campaigns/318"
                                element={<QtwoWearAndTear />}
                            /> */}
                            {/* <Route
                                path="campaigns/369"
                                element={<AugustGoldenTicket />}
                            /> */}
                            {/* <Route
                                path="campaigns/370"
                                element={<BrakePadsIncentive />}
                            /> */}
                            <Route
                                path="campaigns/372"
                                element={<FocusOnBatteries />}
                            />
                            <Route
                                path="campaigns/373"
                                element={<EvhcFocus />}
                            />
                            <Route
                                path="campaigns/412"
                                element={<OptimumFriction />}
                            />
                            {/* <Route
                                path="campaigns/373"
                                element={<EvhcFocusDoublePoints />}
                            /> */}
                            <Route
                                path="campaigns/374"
                                element={<ServiceStars />}
                            />
                            <Route
                                path="campaigns/375"
                                element={<TpmCuttingEdge />}
                            />
                            <Route
                                path="campaigns/376"
                                element={<RenaultRewardsCampaign />}
                            />
                            <Route
                                path="campaigns/377"
                                element={<MotrioPaydays />}
                            />
                            <Route
                                path="campaigns/378"
                                element={<MotrioRewardsCampaign />}
                            />
                            {/* <Route
                                path="campaigns/126"
                                element={<TradePartsManagerSpinWin />}
                            /> */}
                            {alpineVisibleCustomerId?.includes(
                                userProfileDetails?.userId,
                            ) && (
                                <>
                                    <Route
                                        path="campaigns/130"
                                        element={<AlpineCustomerExcellence />}
                                    />
                                    <Route
                                        path="campaigns/131"
                                        element={<AlpineCampaign />}
                                    />
                                </>
                            )}
                            <Route
                                path="campaigns/313"
                                element={<ProductTargetIncentivesFebruary />}
                            />
                            {/* <Route
                                path="campaigns/316"
                                element={<CastrolMotoGp />}
                            /> */}
                            <Route
                                path="campaigns/315"
                                element={<IncentiveWearAndTear />}
                            />
                            {/* <Route
                                path="campaigns/330"
                                element={<FullThrottle />}
                            /> */}
                            {/* <Route
                                path="campaigns/278"
                                element={<TradePartsManagerTlcView />}
                            /> */}
                        </>
                    ) : userProfileDetails?.jobRoleId ===
                          participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_TRADE_PARTS_MANAGER &&
                      participantTypeIds.PARTICIPANT ==
                          userProfileDetails?.roleId ? (
                        <>
                            <Route
                                path="campaigns/409"
                                element={<RemanIncentive />}
                            />
                            <Route
                                path="campaigns/378"
                                element={<MotrioRewardsCampaign />}
                            />
                            {/* <Route
                                path="campaigns/126"
                                element={<TradePartsManagerSpinWin />}
                            /> */}
                            {/* <Route
                                path="campaigns/366"
                                element={<CuttingEdgeQuarterThree />}
                            /> */}
                            {/* <Route
                                path="campaigns/367"
                                element={<CuttingEdgeQuarterFour />}
                            /> */}
                            {/* <Route
                                path="campaigns/314"
                                element={<TradePartsManagerIncentive />}
                            /> */}

                            {/* <Route
                                path="campaigns/278"
                                element={<TradePartsManagerTlcView />}
                            /> */}
                            {/* <Route
                                path="campaigns/330"
                                element={<FullThrottle />}
                            /> */}
                            <Route
                                path="campaigns/375"
                                element={<TpmCuttingEdge />}
                            />
                            <Route
                                path="campaigns/376"
                                element={<RenaultRewardsCampaign />}
                            />
                            <Route
                                path="campaigns/377"
                                element={<MotrioPaydays />}
                            />
                        </>
                    ) : (
                        ""
                    )}
                    <Route
                        path="campaigns/comms-page"
                        element={<CommsPage />}
                    />

                    <Route path="learn" element={<KnowlegeWrapper />} />
                    <Route
                        path="learn/all-quizzers"
                        element={<AllQuizzers />}
                    />
                    <Route path="learn/:id" element={<QuizHome />} />
                    <Route path="shop" element={<ShopWrapper />} />
                    <Route path="shop/:id" element={<VoucherDetails />} />
                    <Route
                        path="shop/rebate-voucher"
                        element={<RebateVoucherDetails />}
                    />
                    <Route
                        path="shop/browse-products"
                        element={<BrowseProducts />}
                    />

                    <Route
                        path="shop/confirm-order"
                        element={<OrderConfirmation />}
                    />
                    <Route
                        path="shop/voucher-wallet"
                        element={<VoucherWallet />}
                    />
                    <Route
                        path="shop/order-details/:id"
                        element={<OrderDetails />}
                    />

                    <Route
                        path="points-banking"
                        element={<RenaultPointsBankingWrapper />}
                    />
                    {/* <Route
                        path="renault-points-banking"
                        element={<RenaultPointsBankingWrapper />}
                    /> */}

                    <Route
                        path="campaigns/comms/1"
                        element={<CommsPageOne />}
                    />
                    <Route
                        path="campaigns/comms/2"
                        element={<CommsPageTwo />}
                    />
                    <Route path="comms-page-03" element={<CommsPageThree />} />
                    <Route path="comms-page-04" element={<CommsPageFour />} />
                    <Route
                        path="campaigns/comms/5"
                        element={<CommsPageFive />}
                    />
                    <Route
                        path="campaigns/comms/6"
                        element={<CommsPageSix />}
                    />

                    <Route
                        path="campaigns/comms/7"
                        element={<CommsPageSeven />}
                    />

                    <Route
                        path="campaigns/comms/8"
                        element={<CommsPageEight />}
                    />

                    <Route
                        path="campaigns/comms/32"
                        element={<CommsPageMotrio />}
                    />

                    <Route path="shop/my-basket" element={<MyBasket />} />
                    <Route path="*" element={<Navigate to="/app/home" />} />
                </Route>

                {RedirectRoutes.map((route) => (
                    <Route
                        key={route.path}
                        path={route.path}
                        element={route.element}
                    />
                ))}
                {/* Private routes */}
                <Route path="/ui/*" element={<UiRoutes />} />

                <Route path="*" element={<Navigate to="/" />} />
            </Routes>
        </ScrollToTop>
    );
}
